export const CREATE_OFFICE = 'CREATE_OFFICE';
export const CREATE_OFFICE_ERROR = 'CREATE_OFFICE_ERROR';
export const CREATE_OFFICE_REQUEST = 'CREATE_OFFICE_REQUEST';
export const CREATE_OFFICE_SUCCESS = 'CREATE_OFFICE_SUCCESS';

export const DELETE_OFFICE = 'DELETE_OFFICE';
export const DELETE_OFFICE_ERROR = 'DELETE_OFFICE_ERROR';
export const DELETE_OFFICE_REQUEST = 'DELETE_OFFICE_REQUEST';
export const DELETE_OFFICE_SUCCESS = 'DELETE_OFFICE_SUCCESS';

export const EDIT_OFFICE = 'EDIT_OFFICE';
export const EDIT_OFFICE_ERROR = 'EDIT_OFFICE_ERROR';
export const EDIT_OFFICE_REQUEST = 'EDIT_OFFICE_REQUEST';
export const EDIT_OFFICE_SUCCESS = 'EDIT_OFFICE_SUCCESS';

export const GET_OFFICE = 'GET_OFFICE';
export const GET_OFFICE_ERROR = 'GET_OFFICE_ERROR';
export const GET_OFFICE_REQUEST = 'GET_OFFICE_REQUEST';
export const GET_OFFICE_SUCCESS = 'GET_OFFICE_SUCCESS';

export const GET_OFFICES = 'GET_OFFICES';
export const GET_OFFICES_ERROR = 'GET_OFFICES_ERROR';
export const GET_OFFICES_REQUEST = 'GET_OFFICES_REQUEST';
export const GET_OFFICES_SUCCESS = 'GET_OFFICES_SUCCESS';

export const SET_OFFICE = 'SET_OFFICE';
export const SET_OFFICES = 'SET_OFFICES';

export const UPLOAD_OFFICE_LOGO = 'UPLOAD_OFFICE_LOGO';
export const UPLOAD_OFFICE_LOGO_ERROR = 'UPLOAD_OFFICE_LOGO_ERROR';
export const UPLOAD_OFFICE_LOGO_REQUEST = 'UPLOAD_OFFICE_LOGO_REQUEST';
export const UPLOAD_OFFICE_LOGO_SUCCESS = 'UPLOAD_OFFICE_LOGO_SUCCESS';
